import React, { Component } from 'react';
import { StyleSheet, View, TouchableOpacity, Text } from 'react-native';
import { connect } from 'react-redux';
import CheckBox from '../widgets/checkbox';
import NewIssue from "../dialogs/newIssue";

export default class YesNo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      dialogVisible: false,
    };
  }

  // set initial value
  componentWillMount(nextProps, nextState) {
    this.setState({value: this.props.initial});
  }

  render() {
    const { value } = this.state;
    const { label, onChange, id, isIssuable, onSubmitIssue, isCompleted, placeholder } = this.props;
    console.log(label)
    return <>    
    <View style={label.length<50 && label.length>15? styles.container:styles.container2}>
    <CheckBox initial={this.props.initial} onPress={(val) => { console.log('CHECKBOX value: ' + val); this.setState({value: val}); onChange(id, val); }} /> 
    <Text style={styles.label}>{label+" "}<Text style={{fontStyle: 'italic',color: '#002f6c',fontSize: 20,}}>{placeholder}</Text></Text>
    
      {
        (isIssuable && isCompleted) && 
        <TouchableOpacity style={{paddingBottom:10, paddingTop:5}} onPress={() => {
          this.setState({dialogVisible:true});
        }}>
          <Text style={{color:'#002F6C', fontWeight:'bold', marginTop: 5}}>Issue</Text>  
        </TouchableOpacity>
      }

    </View>
    <NewIssue 
      visible={this.state.dialogVisible} 
      id={id} 
      label={label} 
      onSubmitIssue={onSubmitIssue} 
      handleClose={()=>this.setState({dialogVisible:false})} 
      /> 
    </>;
  }
}

const styles = StyleSheet.create({
  container: {
    alignSelf: 'stretch',
    alignItems: 'stretch',
    flexDirection: "row",
    paddingLeft: 15,
    paddingRight: 10,
    paddingBottom:15,
    paddingTop:15,
  },
  container2: {
    alignSelf: 'stretch',
    alignItems: 'stretch',
    flexDirection: "row",
    paddingLeft: 15,
    paddingRight: 10,
    paddingBottom:25,
    paddingTop:25,
  },
  container3: {
    alignSelf: 'stretch',
    alignItems: 'stretch',
    flexDirection: "row",
    paddingLeft: 15,
    paddingRight: 10,
    paddingBottom:15,
    paddingTop:15,
  },
  label: {
    marginTop: 5,
    fontSize: 20,
    color: '#939598',
    fontWeight: '300',
    fontFamily: 'Roboto',
  },
});
